
import "./Statistica.css";
import React, { useEffect, useState } from "react";
import { business } from "./BusinessTypeChart"
import { Cell, Legend, Pie, PieChart, Tooltip } from "recharts";
import CancelTypeData from './CancelTypeData';

const COLORS = ["#F5D493", "#A6A6F5", "#A6E8F5", "#CEF5A6", "#F5B1A6"];

const CustomTooltip = ({ payload, allCount } : { payload: any, allCount: number }) => {
    if (payload) {
        return (
            <div
                className = "custom-tooltip"
                style = {{
                    width: "auto",
                    height: "60px",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "#ffff",
                    padding: "5px 10px",
                    boxShadow: "0 0 5px rgba(0,0,0,0.5)",
                    borderRadius: "7px"
                }}
            >
                <label className = "circleChartValueText">{ `${payload[0]?.name}` }</label>
                <label className = "circleChartValueText">{ `${payload[0]?.value}  (${Math.round(payload[0]?.value / allCount * 100)}%)` }</label>
            </div>
        );
    }
    return null
}

const RenderLegend = (props: any) => {
    const [showCanceledClients, setShowCanceledClients] = useState<boolean>(false);
    const [clientData, setClientData] = useState<any>();
    const { payload } = props;

    const showClients = (data: any) => {
        if (data.payload?.clients) {
            setClientData(data);
            setShowCanceledClients(true);
        }
    }

    return (
        <ul className='cancel-reasons-list'>
            {
                payload.filter((item: any) => item.payload.value > 0)?.map((entry: any, index: number) => (
                    <li
                        key = {`item-${index}`}
                        style = {{
                            color: entry.color,
                            cursor: 'pointer'
                        }}
                        onClick = { () => showClients(entry) }
                    >
                        { entry?.value && `${entry?.value} (${entry?.payload.value})`}
                    </li>
                ))
            }
            {
                clientData &&
                    <CancelTypeData
                        showCanceledClients = { showCanceledClients }
                        setShowCanceledClients = { setShowCanceledClients }
                        clientData = { clientData.payload }
                        setClientData = { setClientData }
                    />
            }
        </ul>
    )
}

function ReasonChart({ reasons, showDate } : { reasons: any, showDate: string[] }) {
    const [pieData, setPieData] = useState<Array<business>>([
        {
            id: "Family Emergency",
            key: "Family Emergency",
            clients: [],
            value: 0
        },
        {
            id: "Out of the Country",
            key: "Out of the Country",
            clients: [],
            value: 0
        },
        {
            id: "Out of Business",
            key: "Out of Business",
            clients: [],
            value: 0
        },
        {
            id: "No Funds",
            key: "No Funds",
            clients: [],
            value: 0
        },
        {
            id: "Content",
            key: "Content",
            clients: [],
            value: 0
        },
        {
            id: "Our Mistake (Wrong Info)",
            key: "Our Mistake (Wrong Info)",
            clients: [],
            value: 0
        },
        {
            id: "Our Mistake (Grammar Issues)",
            key: "Our Mistake (Grammar Issues)",
            clients: [],
            value: 0
        },
        {
            id: "Business change",
            key: "Business change",
            clients: [],
            value: 0
        },
        {
            id: "Brokerage Has Our Service",
            key: "Brokerage Has Our Service",
            clients: [],
            value: 0
        },
        {
            id: "Requests Being Late",
            key: "Requests Being Late",
            clients: [],
            value: 0
        },
        {
            id: "No Answer to our Calls/Emails",
            key: "No Answer to our Calls/Emails",
            clients: [],
            value: 0
        },
        {
            id: "Ad Campaign",
            key: "Ad Campaign",
            clients: [],
            value: 0
        },
        {
            id: "Dissatisfaction with the quality of service",
            key: "Dissatisfaction with the quality of service",
            clients: [],
            value: 0
        },
        {
            id: "No Payment or Response (Trial)",
            key: "No Payment or Response (Trial)",
            clients: [],
            value: 0
        },
        {
            id: "No Payment or Response (Not Trial)",
            key: "No Payment or Response (Not Trial)",
            clients: [],
            value: 0
        },
        {
            id: "Disputed",
            key: "Disputed",
            clients: [],
            value: 0
        },
        {
            id: "Issues with AM",
            key: "Issues with AM",
            clients: [],
            value: 0
        },
        {
            id: "No Results",
            key: "No Results",
            clients: [],
            value: 0
        },
        {
            id: "Doesn't need our services",
            key: "Doesn't need our services",
            clients: [],
            value: 0
        },
        {
            id: "Other",
            key: "Other",
            clients: [],
            value: 0
        }
    ]);
    const [allCount, setAllCount] = useState<number>(0);
    const [showCanceledClients, setShowCanceledClients] = useState<boolean>(false);
    const [clientData, setClientData] = useState<any>();

    const openCanceledClients = (data: any) => {
        setShowCanceledClients(true);
        setClientData(data);
    }

    useEffect(() => {
        setPieData([
                {
                    id: "Family Emergency",
                    key: "Family Emergency",
                    value: 0
                },
                {
                    id: "Out of the Country",
                    key: "Out of the Country",
                    value: 0
                },
                {
                    id: "Out of Business",
                    key: "Out of Business",
                    value: 0
                },
                {
                    id: "No Funds",
                    key: "No Funds",
                    value: 0
                },
                {
                    id: "Content",
                    key: "Content",
                    value: 0
                },
                {
                    id: "Our Mistake (Wrong Info)",
                    key: "Our Mistake (Wrong Info)",
                    value: 0
                },
                {
                    id: "Our Mistake (Grammar Issues)",
                    key: "Our Mistake (Grammar Issues)",
                    value: 0
                },
                {
                    id: "Business change",
                    key: "Business change",
                    value: 0
                },
                {
                    id: "Brokerage Has Our Service",
                    key: "Brokerage Has Our Service",
                    value: 0
                },
                {
                    id: "Requests Being Late",
                    key: "Requests Being Late",
                    value: 0
                },
                {
                    id: "No Answer to our Calls/Emails",
                    key: "No Answer to our Calls/Emails",
                    value: 0
                },
                {
                    id: "Ad Campaign",
                    key: "Ad Campaign",
                    value: 0
                },
                {
                    id: "Dissatisfaction with the quality of service",
                    key: "Dissatisfaction with the quality of service",
                    value: 0
                },
                {
                    id: "No Payment or Response (Trial)",
                    key: "No Payment or Response (Trial)",
                    clients: [],
                    value: 0
                },
                {
                    id: "No Payment or Response (Not Trial)",
                    key: "No Payment or Response (Not Trial)",
                    clients: [],
                    value: 0
                },
                {
                    id: "Issues with AM",
                    key: "Issues with AM",
                    clients: [],
                    value: 0
                },
                {
                    id: "No Results",
                    key: "No Results",
                    clients: [],
                    value: 0
                },
                {
                    id: "Disputed",
                    key: "Disputed",
                    clients: [],
                    value: 0
                },
                {
                    id: "Doesn't need our services",
                    key: "Doesn't need our services",
                    clients: [],
                    value: 0
                },
                {
                    id: "Other",
                    key: "Other",
                    value: 0
                }
            ]
        )
        if (reasons) {
            let packageData = new Array();
            for (let key in reasons) {
                const findDay = showDate.find((date: string) => date === key);
                if (findDay) {
                    reasons[key].forEach((item: any) => packageData.push(item));
                }
            }

            if (packageData.length > 0) {
                packageData.forEach(item => {
                    setPieData(pieData => pieData.map(pie => pie.id === item.key ? {
                        ...pie,
                        value: Number(pie.value) + Number(item.value),
                        clients: pie.clients ? pie.clients.concat(item.clients) : item.clients
                    } : { ...pie }))
                })
            }
        }
    }, [reasons, showDate])

    useEffect(() => {
        const allAddClients: number = pieData.reduce((count: number, elem: business) => count += elem.value, 0);
        setAllCount(allAddClients);
    }, [pieData])

    return (
        <div className = "ReasonChart">
            <div className = "piechart-header-box">
                Reason Cancellation
            </div>
            <PieChart
                width = { window.innerWidth > 500 ? 350 : 250 }
                height = { window.innerWidth > 500 ? 350 : 250 }
            >
                <Pie
                    data = { pieData }
                    labelLine = { false }
                    color = "#000000"
                    dataKey = "value"
                    nameKey = "key"
                    cx = "50%"
                    cy = "50%"
                    outerRadius = { window.innerWidth > 500 ? 150 : 100 }
                    fill = "#8884d8"
                >
                    {
                        pieData.map((entry, index) => {
                            return(
                                <Cell
                                    style = {{ outline: "none" }}
                                    key = {`cell-${index}`}
                                    fill = {
                                        COLORS[index % COLORS.length]
                                    }
                                    onClick = {() => openCanceledClients(entry)}
                                />
                            )
                        })
                    }
                </Pie>
                <Tooltip content = { <CustomTooltip payload = { pieData } allCount = { allCount }/> }/>
                <Legend
                    width = { 400 }
                    layout = { "vertical" }
                    align = "center"
                    content = { <RenderLegend payload = { pieData }/> }
                />
            </PieChart>
            {
                clientData &&
                    <CancelTypeData
                        showCanceledClients = { showCanceledClients }
                        setShowCanceledClients = { setShowCanceledClients }
                        clientData = { clientData }
                        setClientData = { setClientData }
                    />
            }
        </div>
    )
}

export default ReasonChart
